/* global document, alert, FileReader, setTimeout */

import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import closeIcon from 'resources/close_icon.png'
import upload from 'resources/upload_icon.png'
import CircularProgress from 'material-ui/CircularProgress'

import Utils from '../Utils'
import parse from 'csv-parse/lib/es5/sync'
import _ from 'lodash'

const STANDBY = 'standBy'
const LOADING = 'loading'
const UPLOADED = 'uploaded'

const Actions = ({ onCancelClicked }) => {
  return (
    <div style={styles.actions}>
      <FlatButton
        label='Cancel'
        onTouchTap={onCancelClicked}/>
    </div>
  )
}

Actions.propTypes = {
  onCancelClicked: PropTypes.func.isRequired
}

const Header = ({ title, onCloseRequested }) => {
  return (
    <div style={styles.header}>
      <div style={styles.heading}>
        { title }
      </div>
      <div style={{ marginRight: 16 }}>
        <img src={closeIcon} title='Close' width={16}
          onClick={onCloseRequested}
          style={{ cursor: 'pointer', marginLeft: 8 }} />
      </div>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  onCloseRequested: PropTypes.func.isRequired
}


class CustomerExportDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    teamId: PropTypes.string.isRequired,
    onCloseRequest: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      validationErrorField: null,
      mode: STANDBY
    }
  }

  downloadSampleTemplate = () => {
    Utils.exportSampleTemplate()
  }

  handleUploadClicked = event => {
    event.preventDefault()
    document.querySelector('input[name=\'customers-upload\']').click()
  }

  prepareOffboarding = () => {
    setTimeout(() => {
      this.setState({mode: STANDBY, customers: {}})
      this.props.onCloseRequest()
    }, 2000)
  }

  onFileLoad = e => {
    if (e.target && e.target.result) {
      const customers = parse(e.target.result, { columns: true, relax_column_count: true, trim: true })
      this.setState({mode: LOADING})
      Utils
        .uploadCustomersFromCSV(this.props.teamId, customers)
        .then(response => {
          this.setState({ mode: UPLOADED,  customers: response})
          this.prepareOffboarding()
        })
        .catch(() => {
          this.setState({ loading: false, validationErrorField: 'onUpload'})
        })
    }
  }

  onFileInputChange = event => {
    const file = event.target.files[0]
    if (file) {
      if (!file.type.match('csv')) {
        alert('Error, expeted CSV file.')
      }
      else {
        const reader = new FileReader()
        reader.onload = this.onFileLoad
        reader.readAsText(file)
      }
    }
  }

  returnLoadingState = () => {
    return (
      <div style={styles.progress}>
        <CircularProgress thickness={2} />
      </div>
    )
  }

  returnBeforeUploadState = () => {
    return (
      <div>
        <div
          style={styles.downloadTemplate}
          onClick={this.downloadSampleTemplate}>
          Download our customer CSV template.
        </div>
        <div
          style={styles.infoTemplate}>
          You can use it as a template for creating your CSV file.
        </div>
        <div
          style={styles.infoTemplate}>
          Note: Rows with same <b>Customer Name</b> and <b>Customer Id</b> will be grouped under same Customer.
        </div>
        <FlatButton
          label='Upload'
          style={styles.actionButton}
          labelStyle={styles.buttonLabel}
          icon={<img src={upload} height={24} width={24} />}
          onTouchTap={this.handleUploadClicked}>
          <input style={{ display: 'none' }} type='file' name='customers-upload' onChange={this.onFileInputChange}
            multiple/>
        </FlatButton>
      </div>
    )
  }

  returnAfterUploadState = (customers) => {
    if (customers){
      const recordNo = _.keys(customers).length
      const text = recordNo > 1
        ? recordNo + ' customers have been successfully uploaded.'
        : 'Customer has been successfully uploaded.'
      return (
        <div>
          <div style={styles.afterUpload}>
            { text }
          </div>
        </div>
      )
    }
  }

  render() {
    if (!this.props.open) {
      return null
    }

    let content = null
    if (this.state.mode === LOADING){
      content = this.returnLoadingState()
    } else if (this.state.mode === UPLOADED){
      content = this.returnAfterUploadState(this.state.customers)
    } else {
      content = this.returnBeforeUploadState()
    }

    return (
      <Dialog open={this.props.open}
        onRequestClose={this.props.onCloseRequest}
        actions={
          <Actions
            onCancelClicked={this.props.onCloseRequest}
            onSaveClicked={this.handleSaveClicked} />
        }
        title={
          <Header
            title={'Upload Customers'}
            onCloseRequested={this.props.onCloseRequest} />
        }
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}
        actionsContainerStyle={{ padding: 0 }}>
        <div style={styles.container}>
          {content}
        </div>
      </Dialog>
    )
  }

}

export default CustomerExportDialog

const styles = {
  progress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 22
  },
  afterUpload: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignSelf: 'center',
    margin: 8,
    fontSize: 14,
    fontWeight: 400
  },
  downloadTemplate: {
    color: '#4a90e2',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 400,
    marginTop: 8,
    marginBottom: 8
  },
  infoTemplate: {
    fontSize: 14,
    fontWeight: 400,
    marginTop: 8,
    marginBottom: 8
  },
  actionButton: {
    borderRadius: 3,
    backgroundColor: '#356992'
  },
  buttonLabel: {
    color: 'white',
    fontSize: 14,
    fontWeight: 400
  },
  dialogContent: {
    borderRadius: 4,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width: 360
  },
  container: {
    padding: 16,
    height: 160
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: 4
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 48,
    paddingRight: 16,
    backgroundColor: '#fafafa'
  },
  header: {
    display: 'flex',
    displayDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 48,
    backgroundColor: '#fafafa'
  },
  heading: {
    fontSize: 16,
    marginLeft: 16,
    color: '#212121'
  }
}



// WEBPACK FOOTER //
// ./src/customer/common/CustomerExportDialog.js